"use client";

import { useEffect, useState } from 'react';

import { useLanguage } from "@/app/utils/LanguageContext";
import Remarks from "@/app/ui/Common/remarks";
import Footer from "@/app/ui/footer";
import { useParams, usePathname } from 'next/navigation';
import Header from "@/app/ui/header";
import HeaderNav from "@/app/ui/headernav";
import { getJockeyRanking, getCurrentSeasonDate, getPreviousSeasonDate} from "@/app/utils/request/requestList";
import _ from 'lodash';
import NoInformation from "../Common/NoInformation";
import {setRouting, getSearchParams, formattedNumber, getAssetPrefix, adobeData, updateMetaTag} from "@/app/utils/Common";
import { pageSet } from "@/app/utils/pageSet";
import { formattedDate, dateFormat, toDate } from "@/app/utils/DayJS";
const JockeyRanking: React.FC = () => {

  const { state: lang } = useLanguage();

  const [data, setData] = useState<any>(null);
  const [jockeysData, setJockeysData] = useState<any>(null); 

  const {racecourse, view, season } = typeof window !== 'undefined' && getSearchParams(new URLSearchParams(window?.location?.search)); 
 
  // console.log("getSearchParams", getSearchParams(typeof window !== 'undefined' && new URLSearchParams(window?.location?.search)))
  // const [curRacecourse, setCurRacecourse] = useState<string>(racecourse ?? "ALL"); 
  // const [curView, setCurView] = useState((view ?? "numbers").toLowerCase() == "numbers" ? "Numbers" : "Percentage");
  // const [curSeason, setCurSeason] = useState<string>(season ?? "Current");
  const [curRacecourse, setCurRacecourse] = useState<string>(""); 
  const [curView, setCurView] = useState("");
  const [curSeason, setCurSeason] = useState<string>("");
  const [seasonCode, setSeasonCode] = useState<string>("");
  const [seasonDate, setSeasonDate] = useState<string>("");
  //const [season, setSeason] = useState<string>("");
  //1: hasData, 2: noinfo
  const [hasData, setHasData] = useState(1);
  const [venueTrackTypeOption, setVenueTrackTypeOption] = useState<any>(null);
   
  const assetPrefix = getAssetPrefix();
  const { t, langCode } = lang;
  const venueTrackTypeOption_origin = [
    { name_en: "All", name_cn: "所有場地", val: "ALL", isSelect: true },
    { name_en: "ST Turf", name_cn: "沙田草地", val: "STT", isSelect: false },
    { name_en: "ST AWT", name_cn: "沙田全天候", val: "STA", isSelect: false },
    { name_en: "HV Turf", name_cn: "跑馬地草地", val: "HVT", isSelect: false },
    { name_en: "CH Turf", name_cn: "從化草地", val: "CHT", isSelect: false },
  ]

  const venueTrackTypeOption_add_crc = [ 
    { name_en: "CH AWT", name_cn: "從化全天候", val: "CHA", isSelect: false }
  ]

  //get CMS Data
  useEffect(() => {
    const Local_Include_CHA = window.globalConfig?.OTHERS?.Local_Include_CHA ?? "N";
    if(Local_Include_CHA == "Y"){ 
      setVenueTrackTypeOption(venueTrackTypeOption_origin.concat(venueTrackTypeOption_add_crc));
    }else {
      setVenueTrackTypeOption(venueTrackTypeOption_origin);
    } 
    console.log("venueTrackTypeOption", Local_Include_CHA, venueTrackTypeOption_origin);
    updateMetaTag(lang.langCode, pageSet.jockeyranking);
    setCurRacecourse(racecourse ?? "ALL")
    setCurView((view ?? "numbers").toLowerCase() == "numbers" ? "Numbers" : "Percentage");
    setCurSeason(season ?? "Current"); 

    adobeData(langCode, "pageview", {
      pageId: "racing/local",
    });
  }, [])

  const sortSeason = (s: any) => {
    return Number(s?.code?.split("/")?.[0] ?? 0)
  }
  //get QIDS Data
  useEffect(() => { 
    if(curSeason != "") {
      getPreviousSeasonDate("LOCAL").then((res) => {
        if(!res)
        {
          setHasData(2);
          return;
        } 
        console.log("getSeason", res?.racingSeasonPeriod) 
        const racingSeason = _.orderBy(res?.racingSeasonPeriod, [sortSeason], ["desc"])
        if(curSeason == "Current"){  
          const seasonCur = racingSeason?.[0]?.code
          setSeasonCode(seasonCur)   
          getCurrentSeasonDate().then((resCur) => { 
            const sn = resCur?.lastMeeting?.season ?? "";
            if(seasonCur == sn){
              const date = resCur?.lastMeeting?.date ? formattedDate(toDate(resCur?.lastMeeting?.date, dateFormat.display.date), dateFormat.display.date) : ""
              setSeasonDate(date); 
            }else {
              setSeasonDate(""); 
            }  
            console.log("getCurrentSeasonDate", resCur?.lastMeeting?.date, sn, racingSeason?.[0]?.code);
          }); 
        }else {
          const date = formattedDate(toDate(racingSeason?.[1].endDate?.split("+")[0], dateFormat.display.date), dateFormat.display.date) 
          setSeasonDate(date); // Previous Season Date 
          setSeasonCode(racingSeason?.[1]?.code) //Previous Season
          console.log("getPreviousSeasonDate", racingSeason?.[1].endDate?.split("+")[0], racingSeason?.[1]?.code);
        }
      }); 

      // if(curSeason == "Current"){   
      //   getCurrentSeasonDate().then((res) => { 
      //     console.log("getCurrentSeasonDate", res?.lastMeeting?.date, res?.lastMeeting?.season);
      //     const date = formattedDate(toDate(res?.lastMeeting?.date, dateFormat.display.date), dateFormat.display.date)
      //     setSeasonDate(date);
      //     setSeasonCode(res?.lastMeeting?.season)
      //   });
      // }else {
      //   getPreviousSeasonDate("LOCAL").then((res) => { 
      //     console.log("getPreviousSeasonDate", res?.racingSeasonPeriod?.[0].endDate?.split("+")[0], res?.racingSeasonPeriod?.[0]?.code);
      //     const date = formattedDate(toDate(res?.racingSeasonPeriod?.[1].endDate?.split("+")[0], dateFormat.display.date), dateFormat.display.date)
      //     setSeasonDate(date); // Previous Season Date
      //     setSeasonCode(res?.racingSeasonPeriod?.[1]?.code) //Previous Season
      //   });
      // }  
    }
  }, [season])  

  useEffect(() => {
    if(seasonCode){ 
      getJockeyRanking(seasonCode)
      .then((res: any) => {
        if(!res)
        {
          setHasData(2);
          return;
        } 
        //const ss = season == "Current" ? sss : sss.filter(x=> x.isCurrent == false)
        console.log("getJockeyRanking", res?.jockeyStat, seasonCode)  
        setData(res?.jockeyStat); 
        //setSeasonCode(res?.jockeyStat?.[0]?.season);
        
      })
      .catch((e: any) => {
        console.log(e);
      }); 
    }
  }, [seasonCode])
 
  useEffect(() => {
    setRouting(undefined, {'season': curSeason, 'view': curView, 'racecourse': curRacecourse,}, null); 
  }, [curView, curSeason, curRacecourse]) 

  useEffect(() => { 
    const handleClickBack =()=> { 
      const {racecourse, view, season } = typeof window !== 'undefined' && getSearchParams(new URLSearchParams(window?.location?.search)); 
      console.log("handleClickBack") 
      setCurRacecourse(racecourse ?? "ALL")
      setCurView((view ?? "numbers").toLowerCase() == "numbers" ? "Numbers" : "Percentage");
      setCurSeason(season ?? "Current");
    }
    window.addEventListener("popstate", handleClickBack);
    return () => {
        window.removeEventListener("popstate", handleClickBack);
    };
  }, []) 
  

  const changeVenueTrackType = (event: any) => {
    const val = event.target.value;
    setCurRacecourse(val);   
    //location.href = `/${lang?.langCode}/information/jockeyranking?Season=${season}&View=${view}&Racecourse=${val}`; 
  }

  const previousSeason = () => {
    const curS = curSeason == "Current" ? "Previous" : "Current";
    setCurSeason(curS);
    //location.href = `/${lang?.langCode}/information/jockeyranking?Season=${curSeason}&View=${view}&Racecourse=${racecourse}`;
  }

  const onclickPercentageOrNumber = () => {
    const type = curView == "Numbers" ? "Percentage" : "Numbers";
    setCurView(type);
    //location.href = `/${lang?.langCode}/information/jockeyranking?Season=${season}&View=${type}&Racecourse=${racecourse}`; 
  }
 
  //get CMS Data
  useEffect(() => { 
    handleTableData();
  }, [data, curRacecourse])

  const initPreformance = (item: any) => {
    const total = Number(item?.numStarts ?? 0) ; 
    const first = total > 0 ? ((Number(item?.numFirst ?? 0) / total) * 100).toFixed(0) : 0;
    const second = total > 0 ? ((Number(item?.numSecond ?? 0) / total) * 100).toFixed(0) : 0;
    const third = total > 0 ? ((Number(item?.numThird ?? 0) / total) * 100).toFixed(0) : 0;
    const fourth = total > 0 ? ((Number(item?.numFourth ?? 0) / total) * 100).toFixed(0) : 0;
    const five = total > 0 ? ((Number(item?.numFifth ?? 0) / total) * 100).toFixed(0) : 0;
    const percentage = { 
      win: total >= 0 ? first + "%" : '-',
      second: total >= 0 ? second + "%" : '-',
      third: total >= 0 ? third + "%" : '-',
      fourth: total >= 0 ? fourth + "%" : '-',
      five: total >= 0 ? five + "%" : '-', 
      totalRides: total,
      stakesWon: "$" + formattedNumber(Number(Number(item?.stakeWon ?? 0)?.toFixed(0))),
    } 
    return percentage
  }
  
  const handleTableData = () => {
    
    const jockeyStat = data?.map((item: any) => { //res?.trainerStat? 
      let ssnStat = null; 
      let dhStat = null;
      if(curRacecourse != "ALL"){
        //ssnStat = item?.ssnStat?.find((x: any) => x.ven != "" && curRacecourse == (x.ven + x.trk)?.substring(0, 3));
 
        const ssnStatList = item?.ssnStat?.filter((x: any) =>  x.ven != "" && curRacecourse == (x.ven + x.trk)?.substring(0, 3));
        if(ssnStatList && ssnStatList.length > 0) {
          ssnStat = {
            numFirst: ssnStatList.reduce((sum: number, val: any) => sum + Number(val.numFirst), 0),
            numSecond: ssnStatList.reduce((sum: number, val: any) => sum + Number(val.numSecond), 0),
            numThird: ssnStatList.reduce((sum: number, val: any) => sum + Number(val.numThird), 0),
            numFourth: ssnStatList.reduce((sum: number, val: any) => sum + Number(val.numFourth), 0),
            numFifth: ssnStatList.reduce((sum: number, val: any) => sum + Number(val.numFifth), 0),
            numStarts: ssnStatList.reduce((sum: number, val: any) => sum + Number(val.numStarts), 0),
            ven: ssnStatList[0]?.ven,
            trk: ssnStatList[0]?.trk
          }
        }
        
        const dhStatList = item?.dhStat?.filter((x: any) =>  x.ven != "" && curRacecourse == (x.ven + x.trk)?.substring(0, 3));
        if(dhStatList && dhStatList.length > 0) {
          dhStat = {
            numFirst: dhStatList.reduce((sum: number, val: any) => sum + Number(val.numFirst), 0),
            numSecond: dhStatList.reduce((sum: number, val: any) => sum + Number(val.numSecond), 0),
            numThird: dhStatList.reduce((sum: number, val: any) => sum + Number(val.numThird), 0),
            numFourth: dhStatList.reduce((sum: number, val: any) => sum + Number(val.numFourth), 0),
            numFifth: dhStatList.reduce((sum: number, val: any) => sum + Number(val.numFifth), 0), 
            ven: dhStatList[0]?.ven,
            trk: dhStatList[0]?.trk
          }
        }

      }else {
        ssnStat = item?.ssnStat?.find((x: any) => curRacecourse == x.ven);
        dhStat = item?.dhStat?.find((x: any) => curRacecourse == x.ven);
      }  
      const stakeWon = Number(ssnStat?.stakeWon ?? 0)
      return {
        name: lang.langCode == "en-us" ? item.name_en : item.name_ch,
        name_en: item.name_en?.toUpperCase(),
        jockeyId: item.code,
        status: item.status,
        
        Numbers: (curRacecourse != "ALL" && !ssnStat) ? null : {
          win: ssnStat?.numFirst ?? 0, 
          second: ssnStat?.numSecond ?? 0, 
          third: ssnStat?.numThird ?? 0, 
          fourth: ssnStat?.numFourth ?? 0, 
          five: ssnStat?.numFifth ?? 0, 
          totalRides: Number(ssnStat?.numStarts ?? 0),
          stakesWon: "$" + formattedNumber(Number(stakeWon?.toFixed(0))),
          racecourse: ssnStat?.ven ? (ssnStat?.ven + ssnStat?.trk)?.substring(0, 3) : ""
        },
        dhStat: {
          numFirst: dhStat?.numFirst ?? 0, 
          numSecond: dhStat?.numSecond ?? 0, 
          numThird: dhStat?.numThird ?? 0, 
          numFourth: dhStat?.numFourth ?? 0, 
          numFifth: dhStat?.numFifth ?? 0
        },
        Percentage: initPreformance(ssnStat)
      } 
    });
    console.log("jockeyStat", jockeyStat)

     const curD = _.orderBy(jockeyStat?.filter((x: any) => x.Numbers != null), 
     ["Numbers.win", "dhStat.numFirst",
     "Numbers.second", "dhStat.numSecond",
     "Numbers.third", "dhStat.numThird",
     "Numbers.fourth", "dhStat.numFourth",
     "Numbers.five", "dhStat.numFifth",
     "Numbers.totalRides", "name_en"], 
     ["desc", "asc",
     "desc", "asc",
     "desc", "asc",
     "desc", "asc",
     "desc", "asc",
     "asc", "asc"]);  
    
      if(curSeason == "Current")
          setJockeysData({jockeys: curD?.filter((x: any)=> x.status == "Active") , other: curD?.filter((x: any)=> x.status != "Active" && x.Numbers.totalRides > 0) })
      else setJockeysData({jockeys:curD?.filter((x: any)=> x.Numbers.totalRides > 0)}) 
       
      console.log("handleTableData",jockeysData, curD)
    // if(racecourse !== "ALL"){
    //   curData = {jockeys: data.jockeys.filter((x: any) => x.racecourse == racecourse), other: data.other.filter((x: any) => x.racecourse == racecourse)}
    // }else {
    //   curData = {...data}
    // }
    // console.log("changeVenueTrackType", curData)
    // setJockeysData(curData)
    }


  return (
    <>
      <div id='mainContainer'>
        <Header/>
        <HeaderNav/>
        {hasData == 2 ? <NoInformation type="noinfo" /> :
        <div className="commContent">
          <div className="commTitlePic"><img src={`${assetPrefix}/images/title_jockeys_${lang?.langCode == "en-us" ? "en" : "cn"}.gif`} /></div>
          <div className="ranking" style={{ width: '760px' }}>
            <table className="bg_e6 f_fs14 f_tal" style={{ width: "100%" }}>
              <tbody><tr>
                <td>{curSeason == "Current" ? seasonDate ? t("currentSeasonUp_to_raceMeeting_of") : t("currentSeason") : t("previousSeasonUp_to_raceMeeting_of")} {seasonDate}</td>
                
                <td rowSpan={2} style={{ textAlign: "right", verticalAlign: 'top' }}>
                  <a href="javascript:;" onClick={previousSeason}>
                    {curSeason == "Current" ? t("previousSeason") : t("currentSeason")}
                  </a>
                </td>
              </tr>
                <tr><td className="f_fs13 bg_e6" style={{ color: "#03c" }}>{t("not_included_overseasRecords")}</td></tr>
              </tbody></table>
            <div style={{ textAlign: "right", marginTop: "5px" }}>
              <select style={{ fontSize: "11px" }} id="ddlVenueTrackType" onChange={(event) => changeVenueTrackType(event)}>
                {venueTrackTypeOption?.map((x: any) => {
                  return (<option key={x.val} value={x.val} selected={x.val == racecourse}>{lang?.langCode == "en-us" ? x.name_en : x.name_cn}</option>)
                })}
              </select>
            </div>
            <div style={{ marginTop: "5px" }}>
              <table className="table_bd f_fs13 table_fontfamily_arial_helvetica">
                <thead>
                  <tr className="bg_white">
                    <td width="20%" style={{ fontSize: '14px', fontWeight: "bold", textAlign: "left" }}>{t("jockeysRanking_title")}</td>
                    <td className="f_fs13 f_tac" colSpan={7}>
                      <a href="javascript:;" onClick={onclickPercentageOrNumber}>
                        {curView == "Numbers" ? t("view_Percentage") : t("view_Numbers")}
                      </a>
                    </td>
                  </tr>
                  <tr className="bg_blue_zk color_w font_wb f_tac f_fs14" style={{ fontSize: '14px', fontWeight: 'bold' }}>
                    <td width="160">{t("jockey")}</td>
                    <td width="70">{t("win")}</td>
                    <td width="70">{t("2nd")}</td>
                    <td width="70">{t("3rd")}</td>
                    <td width="70">{t("4th")}</td>
                    <td width="70">{t("5th")}</td>
                    <td width="120">{t("totalRides")}</td>
                    {curRacecourse == "ALL" ? <td>{t("stakesWon")}</td> : null }
                  </tr>
                  {curSeason == "Current" ? <tr className="f_fs13 f_tal"><td colSpan={8}>{t("jockeysRanking_service")}</td></tr> : null}
                </thead> 
                <tbody className="f_tac f_fs12">
                  {jockeysData?.jockeys?.length == 0 ? <><tr><td colSpan={8}>---</td></tr></> : jockeysData?.jockeys?.map((item: any, indx: number) => {
                    return (
                      <tr key={`trianer_${item.name}`}>
                        <td className="f_fs14 f_tal">
                          <a href={`/${lang.langCode}/local/information/jockeypastrec?jockeyid=${item.jockeyId}&season=${curSeason}`}>{item.name}</a>
                        </td>
                        <td>{item[curView].win}</td>
                        <td>{item[curView].second}</td>
                        <td>{item[curView].third}</td>
                        <td>{item[curView].fourth}</td>
                        <td>{item[curView].five}</td>
                        <td>{item[curView].totalRides}</td>
                        {curRacecourse == "ALL" ? <td className="f_tar">{item[curView].stakesWon}</td> : null }
                      </tr>
                    )
                  })} 

                </tbody>
                {
                  curSeason == "Current" ? <> 
                  <tbody><tr><td height="8" colSpan={8}></td></tr>
                    <tr style={{ backgroundColor: 'white' }}><td className="f_fs13 f_tal" colSpan={8}>{t("trainerRanking_other")}</td></tr>
                  </tbody>
                  <tbody className="f_tac f_fs12"> 
                      {jockeysData?.other?.length == 0 ? <><tr><td colSpan={8}>---</td></tr></> : (jockeysData?.other?.map((item: any, indx: number) => {
                      return (
                        <tr key={`other_trianer_${item.name}`}>
                          <td className="f_fs14 f_tal">
                            <a href={`/${lang.langCode}/local/information/jockeypastrec?jockeyid=${item.jockeyId}&season=Current`}>{item.name}</a>
                          </td>
                          <td>{item[curView].win}</td>
                          <td>{item[curView].second}</td>
                          <td>{item[curView].third}</td>
                          <td>{item[curView].fourth}</td>
                          <td>{item[curView].five}</td>
                          <td>{item[curView].totalRides}</td>
                          {curRacecourse == "ALL" ? <td className="f_tar">{item[curView].stakesWon}</td> : null }
                        </tr>
                      )
                    }))}  
                  </tbody>
                </> : null
              }
              </table>
            </div>
          </div>
          <Remarks path="JockeyRanking" customClass=""/>
        </div>
        }
      </div>
      <Footer />
    </>
  );
};
export default JockeyRanking;